import { createExternalApi } from './apiFactory'

export const vehiclesApi = createExternalApi({
  serviceName: 'vehicles',
})
